/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Financial } from '../../models/financial';

export interface FinancialInsuranceDetail$Params {
  ID?: string | null;
  policyno?: string | null;
  grpno?: string | null;
  PatientId?: string | null;
  PracticeId?: string | null;
}

export function financialInsuranceDetail(http: HttpClient, rootUrl: string, params?: FinancialInsuranceDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
  const rb = new RequestBuilder(rootUrl, financialInsuranceDetail.PATH, 'get');
  if (params) {
    rb.query('ID', params.ID, {});
    rb.query('policyno', params.policyno, {});
    rb.query('grpno', params.grpno, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('PracticeId', params.PracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Financial>;
    })
  );
}

financialInsuranceDetail.PATH = '/financial/insurancedetails';
